import type { MetaFunction } from "react-router";

import { INDEX_ROBOTS_DIRECTIVE } from "~/constants/robots";
import { ROUTES } from "~/constants/routing";
import { DashboardPage } from "~/feature/dashboard/pages/DashboardPage";
import { buildDashboardListingMetaJsonLd } from "~/jsonLD/aggregatedEventsFeed";
import { buildSiteJsonLd } from "~/jsonLD/site";
import {
  type DashboardEventsLoaderData,
  loadInitialAggregatedEvents,
} from "~/loaders/dashboardEvents";
import { generateMetaData } from "~/utils/generateMetaData";

import type { Route } from "./+types/home";

export async function loader(): Promise<DashboardEventsLoaderData> {
  return { initialEvents: await loadInitialAggregatedEvents() };
}

export function clientLoader(): DashboardEventsLoaderData {
  return { initialEvents: null };
}

export const meta: MetaFunction = (metaArgs) => {
  return generateMetaData({
    metaArgs,
    robotsDirective: INDEX_ROBOTS_DIRECTIVE,
    jsonLd: [
      buildSiteJsonLd(),
      ...buildDashboardListingMetaJsonLd({
        metaArgs,
        routePath: ROUTES.main.path,
      }),
    ],
  });
};

export default function Home({ loaderData }: Route.ComponentProps) {
  return <DashboardPage initialEvents={loaderData.initialEvents} />;
}
